export default "__VITE_ASSET__a3d51cf4__"